export const getErrorCodes = (code: string) => {
  const errorCodes: {[key: string]: string} = {
    "1000": `Atenção! Seu certificado não é elegível para renovação ou portabilidade.`,
    "1001": `Ops! Algo deu errado.`,
    "1002": `Ops! Algo deu errado.`,
    "1003": `Ops! Sessão não recuperada.`,
    "2000": `Ops! Algo deu errado ao carregar as ofertas.`,
    "2001": `Nenhuma oferta disponível no momento.`,
    "2002": `Ops! Algo deu errado ao carregar as ofertas.`,
    "3000": `Ops! Não conseguimos identificar o certificado.`,
    "4000": `Erro ao gerar o token de acesso.`,
    "5000": `Erro ao carregar as informações do produto`,
    "5001": `Erro ao carregar as informações do produto`,
    "5002": `Erro ao carregar as informações do produto`,
    "5003": `Algo deu errado ao criar seu carrinho`,
    "5004": `Ocorreu um erro ao adicionar o item ao carrinho`,
    "5005": `Ocorreu um erro ao criar seu carrinho ou adicionar um item`,
    "6000": `Algo deu errado ao carregar as ofertas.`,
    "7000": `Erro ao verificar a oferta.`,
    "7001": `Oferta não encontrada.`,
    "8000": `Erro ao verificar dados.`,
    "8001": `Erro na consulta de dados.`,
    "8002": `Ops! Parece que algo está faltando algo.`,
    "8003": `Algo deu errado, mas vamos te ajudar!`,
    "8004": `Algo deu errado. Certificado incompatível.`,
    "8005": `Algo deu errado. CNPJ inválido para o certificado.`,
    "8006": `Algo deu errado. Possível inconsistência no CNPJ.`,
  };
  return errorCodes[code] || `Ocorreu um erro desconhecido`
};

export const getErrorSubTitle = (code: string) => {
  const errorSubtitle: {[key: string]: string} = {
    "1003": `Desculpe. Não conseguimos recuperar sua sessão. Isso pode ocorrer devido a uma falha no processo.`,
    "2000": `Esse é um erro inesperado em nosso sistema, mas não se preocupe!`,
    "2001": `Pode ser que ainda não tenhamos opções configuradas para o tipo do seu certificado.`,
    "2002": `Esse é um erro inesperado em nosso sistema, mas não se preocupe!`,
    "3000": `Houve um problema técnico com as informações do certificado, mas não se preocupe!`,
    "4000": `Houve uma falha momentânea no sistema.`,
    "5000": `Desculpa, houve um problema técnico.`,
    "5001": `Desculpe, ocorreu um problema técnico ao processar as informações.`,
    "5002": `Desculpe, não conseguimos recuperar os detalhes do produto neste momento.`,
    "5003": `Desculpe, tivemos um problema ao processar sua solicitação.`,
    "5004": `Desculpe, tivemos um problema técnico ao processar sua solicitação.`,
    "5005": `Desculpe, houve um problema técnico ao processar sua solicitação.`,
    "6000": `Desculpe pelo transtorno. Esse erro foi gerado por um problema técnico em nosso sistema.`,
    "7000": `Desculpe pelo transtorno. Esse erro é raro e ocorre como uma medida de segurança.`,
    "7001": `Desculpe, não conseguimos encontrar a oferta para o certificado escolhido.`,
    "8000": `Desculpe, ocorreu um erro ao consultar as informações. Esse tipo de falha é raro, mas estamos trabalhando para resolver.`,
    "8001": `A consulta realizada foi rejeitada. Isso pode ocorrer se o CNPJ fornecido não for válido para a sua situação.`,
    "8002": `A oferta selecionada é do tipo PJ, mas não encontramos nenhum CNPJ vinculado à solicitação ou ao certificado.`,
    "8003": `Desculpe pelo transtorno. Esse erro foi gerado por um problema técnico em nosso sistema.`,
    "8004": `Não foi possível validar o certificado de pessoa fisica para a compra de um certificado PJ, pois a empresa não possui associados.`,
    "8005": `O CNPJ fornecido não corresponde a uma pequena empresa, por isso não é compatível com o certificado solicitado.`,
    "8006": `O CNPJ fornecido não corresponde ao tipo de certificado utilizado.`,
  };
  return errorSubtitle[code] || ``
};

export const getErrorSugestions = (code: string) => {
  const errorSugestions: {[key: string]: string} = {
    "1000": `O que você pode fazer agora?`,
    "1001": `Não foi possível ler o certificado. Feche todas as abas do navegador, abra-o novamente e depois:`,
    "1002": `Parece que houve uma instabilidade no sistema.`,
    "1003": `Como resolver:`,
    "2000": `O que você pode fazer?`,
    "2001": `O que você pode fazer?`,
    "2002": `O que você pode fazer?`,
    "3000": `O que você pode fazer?`,
    "4000": `O que você pode fazer?`,
    "5000": `Como resolver?`,
    "5001": `Como resolver?`,
    "5002": `Como resolver?`,
    "5003": `Como resolver?`,
    "5004": `Como resolver?`,
    "5005": `Como resolver?`,
    "6000": `Como resolver?`,
    "7000": `Como resolver?`,
    "7001": `Como resolver?`,
    "8000": `Como resolver?`,
    "8001": `Como resolver?`,
    "8002": `Como resolver?`,
    "8003": `Como resolver?`,
    "8004": `Como resolver:`,
    "8005": `Como resolver:`,
    "8006": `Como resolver:`,
  };
  return errorSugestions[code] || `Como resolver?`
};

export const getErrorMessage = (code: string) => {
  const errorMessage: {[key: string]: string} = {
    "1000": `<li>Confira a validade do certificado: Se ele já expirou, é hora de adquirir um novo.</li> <li>Facilitamos para você! <a href="https://certisign.com.br/monte-seu-certificado">Clique aqui</a> para comprar um novo certificado de forma simples e rápida.</li>`,
    "1001": `<li>confira se o certificado está conectado/instalado no computador.</li><li>confira se o seu certificado já expirou.  Em caso positivo, para prosseguir, <a href="https://certisign.com.br/monte-seu-certificado">solicite um novo aqui neste link</a>.</li>`,
    "1002": `<li>Tente recarregar a página.</li><p>Se o problema persistir ou o certificado estiver vencido, <a href="https://certisign.com.br/certificados">Clique aqui</a> e explore nossas opções de produtos e escolha o seu novo certificado.</p>`,
    "1003": `<li>Reinicie o processo de renovação ou portabilidade.</li><li>Acesse a página de renovação, clicando <a href="https://certisign.com.br/renovacao">aqui</a>.</li><li>Clique no botão para iniciar a leitura do seu certificado no computador.</li>`,
    "2000": `<li><a href="https://certisign.com.br/certificados">Clique aqui</a>,  confira nossos produtos e encontre as melhores opções disponíveis para você.</li>`,
    "2001": `<li><a href="https://certisign.com.br/certificados">Clique aqui</a>,  confira nossos produtos e encontre as melhores opções disponíveis para você.</li>`,
    "2002": `<li><a href="https://certisign.com.br/certificados">Clique aqui</a>,  confira nossos produtos e encontre as melhores opções disponíveis para você.</li>`,
    "3000": `<li><a href="https://certisign.com.br/certificados">Clique aqui</a>,  confira nossos produtos e encontre as melhores opções disponíveis para você.</li>`,
    "4000": `<li>Tente novamente recarregando a página ou <a href="https://certisign.com.br/certificados">clique aqui</a>, confira nossos produtos e encontre as melhores opções disponíveis para você.</li>`,
    "5000": `<li>Tente recarregar novamente a página ou <a href="https://certisign.com.br/certificados">clique aqui</a> para encontrar outras opções.</li>`,
    "5001": `<li>Tente recarregar novamente a página ou <a href="https://certisign.com.br/certificados">clique aqui</a> para encontrar outras opções.</li>`,
    "5002": `<li>Tente recarregar novamente a página ou <a href="https://certisign.com.br/certificados">clique aqui</a> para encontrar outras opções.</li>`,
    "5003": `<li>Tente recarregar novamente a página ou <a href="https://renovacao.certisign.com.br">clique aqui</a> para continuar sua compra.</li>`,
    "5004": `<li>Tente recarregar novamente a página ou <a href="https://renovacao.certisign.com.br">clique aqui</a> para continuar sua compra.</li>`,
    "5005": `<li>Tente recarregar novamente a página ou <a href="https://renovacao.certisign.com.br">clique aqui</a> para continuar sua compra.</li>`,
    "6000": `<li>Tente recarregar novamente a página ou <a href="https://renovacao.certisign.com.br">clique aqui</a> para continuar sua compra.</li>`,
    "7000": `<li>Volte para a vitrine de produtos e tente novamente.</li>`,
    "7001": `<li>Volte para a vitrine de produtos e escolha a melhor opção disponível para você.</li>`,
    "8000": `<li>Tente recarregar novamente a página ou <a href="https://renovacao.certisign.com.br">clique aqui</a> para continuar.</li>`,
    "8001": `<li>Verifique se o CNPJ fornecido está correto.</li><li>Caso tenha se autenticado como Pessoa Física (PF), insira um CNPJ válido.</li><li>Se preferir, você pode acessar nossa vitrine de produtos para continuar.</li>`,
    "8002": `<li>Verifique se os dados estão corretos.</li><li>Caso precise de um novo certificado, você pode conferir nossas opções <a href="https://certisign.com.br/certificados">aqui.</a></li>`,
    "8003": `<li>Tente novamente recarregando a página.</li><li>Se o problema continuar, explore nossas opções de produtos <a href="https://certisign.com.br/certificados">aqui.</a></li>`,
    "8004": `<li>Se estiver comprando para uma empresa, faça login com o certificado e-CNPJ correto.</li><li>Caso contrário, você pode conferir outras opções de certificados <a href="https://certisign.com.br/certificados">aqui.</a></li>`,
    "8005": `<li>Verifique e forneça um CNPJ válido para uma pequena empresa.</li><li>Caso contrário, você pode conferir outras opções de certificados <a href="https://certisign.com.br/certificados">aqui.</a></li>`,
    "8006": `<li>Verifique se os dados do CNPJ estão corretos.</li><li>Clique aqui para contunuar sua compra.</li>`,
  };
  return errorMessage[code] || `Tente recarregar a página.`
}

export const getCtaError = (code: string) => {
  const ctaError: {[key: string]: string} = {
    "1000": `Voltar`,
    "1001": `Tentar novamente`,
    "1002": `Voltar`,
    "1003": `Renovar`,
    "2000": `Voltar`,
    "2001": `Voltar`,
    "2002": `Voltar`,
    "3000": `Voltar`,
    "4000": `Voltar`,
    "5000": `Tentar novamente`,
    "5001": `Tentar novamente`,
    "5002": `Tentar novamente`,
    "5003": `Tentar novamente`,
    "5004": `Tentar novamente`,
    "5005": `Tentar novamente`,
    "6000": `Tentar novamente`,
    "7000": `Voltar para a home`,
    "7001": `Voltar para a home`,
    "8000": `Voltar para a home`,
    "8001": `Voltar para a home`,
    "8002": `Voltar para a home`,
    "8003": `Tentar novamente`,
    "8004": `Voltar para home`,
    "8005": `Voltar para home`,
    "8006": `Voltar para home`,
  };
  return ctaError[code] || `Tentar novamente`;
};